console.log( 'Slider' );

document.addEventListener("DOMContentLoaded", function(){
const prevButton = document.getElementById('j360-image-slider__prev');
const nextButton = document.getElementById('j360-image-slider__next');
let currentSlide = 0;

const numberOfSlides = document.querySelectorAll('.j360-image-slider__slide').length;

console.log(numberOfSlides);

nextButton.addEventListener('click', () => {
  console.log('next');
  if (currentSlide === numberOfSlides - 1) {
    return;
  }
  // hide first element
  currentSlide += 1;
  for (let i = 0; i < currentSlide; i++) {
    document.getElementById('j360-image-slider__slide_' + i).style.display = 'none';
  }
})

prevButton.addEventListener('click', () => {
  console.log('prev');
  // hide first element
  if (currentSlide === 0) {
    return;
  }
  currentSlide -= 1;
  for (let i = currentSlide; i < numberOfSlides; i++) {
    document.getElementById('j360-image-slider__slide_' + i).style.display = 'block';
  }
})

})